import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import Hero from "../components/home/Hero"
import "../tailwind.css"
import Header from "../components/Header"



const Confirm: React.FC = () => {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) { }
	}	  
  useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="">
				<Header />
				<Hero type="promoover" />
				<div className="mx-auto  mb-12 max-w-[90%] text-center md:max-w-[1000px] lg:mt-6 lg:mb-2">
					<h2 className="h2 mt-12 text-[24px] text-orange md:mt-0 md:text-[82px]">Unser Gewinnspiel ist beendet</h2>
					<p className="mb-4 mt-6 px-4 font-Alpro text-[24px] text-blue md:mt-12 md:text-[42px]">Vielen Dank an alle, die an unserer Aktion teilgenommen haben.</p>
					<p className="font-Hurme text-[16px] text-blue md:text-[20px]">Du hast noch Fragen zur Aktion? Kein Problem! Kontaktiere uns einfach per E-Mail unter info@gratistesten.alpro.com.</p>
					<p className="mt-4 text-[16px] text-orange md:text-[20px]">
						Besuche uns gerne auf{" "}
						<a href="https://www.alpro.com" className="underline">
							www.alpro.com
						</a>
						, um nichts zu verpassen.
					</p>
				</div>
				<div className="mx-auto mb-12 max-w-[90%] pb-12 text-center lg:mt-24 lg:pb-24">
					<a
						href="https://www.alpro.com"
						className="mb-6 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px]  lg:inline-block lg:py-2 lg:px-6"
					>
						{" "}
						zur Alpro Website
					</a>
				</div>
			</div>
		</>
	)
}
export default Confirm
